import axios from 'axios'
import {serialize } from 'object-to-formdata'
import VueScrollTo from 'vue-scrollto'

export default {
  data() {
    return {
      form: {},
      isSent: false,
      isSending: false,
      isError: false,
      errorMessage: '',
      serverSideErrors: {},
      formUrl: ''
    }
  },
  provide() {
    const sserrors = {}
    Object.defineProperty(sserrors, 'errors', {
      enumerable: true,
      get: () => this.serverSideErrors
    })
    return { sserrors }
  },
  methods: {
    scrollToError() {
      this.$nextTick(function() {
        let els = document.querySelector('.has-error')
        if (els) {
          VueScrollTo.scrollTo(els, 300, {
            offset: -40
          })
        }
      })
    },

    submit() {
      this.$v.$touch()
      if (!this.$v.$error) {
        this.$v.$reset()
        this.isSending = true
        this.isError = false

        if (this.$recaptcha) {
          this.$recaptcha('send_form').then(token => {
            this.form.recaptcha = token
            this.realSubmit()
          })
        } else {
          this.realSubmit()
        }
      } else {
        //console.log(this.$v.$error);
        this.scrollToError()
      }
    },

    realSubmit() {
      const formData = serialize(this.form)
      console.log(formData);
      this.$set(this, 'serverSideErrors', {})

      axios({
        data: formData,
        method: 'post',
        responseType: 'json',
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url:  this.formUrl
      })
        .then(res => {
          this.isError = true
          this.isSending = false

          if (res.data && res.data.success) {
            this.isError = false
            this.isSent = true
            this.sentData = res.data.object;
            this.$emit('form:sent', res.data.object)
          } else if (res.data && !res.data.success && res.data.object.form) {
            this.errorMessage = res.data.object.form
            this.$emit('form:error', res.data.object.form)
            this.$set(this, 'serverSideErrors', res.data.object)
            this.scrollToError()
          } else {
            this.errorMessage = this.$t('form_error_connection')
            this.$emit('form:error', this.$t('form_error_connection'))
          }
        })
        .catch(() => {
          this.isError = true
          this.isSending = false
          this.errorMessage = this.$t('form_error_connection')
          this.$emit('form:error', this.$t('form_error_connection'))
        })
    }
  }
}
